import React, { useState ,useEffect,useRef} from 'react';

import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {useCookies} from 'react-cookie'
import FileCopyIcon from '@material-ui/icons/FileCopy';
import {  Button, Grid, Typography ,Box} from '@material-ui/core';

import { Snackbar } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import CircularProgress from '@mui/material/CircularProgress';
import Site_Preview from '../customer_site/site_preview';
import SiteManager from './SiteManager/SiteManager';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1),
      width: theme.spacing(30),
      height: theme.spacing(30),
    },
  },
  'search-box-wrapper': {
    backgroundColor: '#ffffff',
    height: '48px',
    borderRadius: '4px',
    // minWidth: '130px',
    width: '100%',
    border: '1px solid rgb(97, 18, 107)',
    display: 'flex',
    paddingLeft: '10px',
    justifyContent: 'space-between',
    margin: '0px auto 10px ', 
    // position: 'absolute',
    // top:'20%',
    // left: '50%',
    // marginLeft: '-350px',
  },
  'search-field': {
    height: '46px',
    width: 'calc(100% - 150px)',
    display: 'flex',
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
}));
function Alert1(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function Businee(props) {
    const {live}=props
  const [copy,setCopy]=useState(false)
    const myRef = useRef()
    const[auth,setAuth]=useCookies(['auth'])
    const [business,setBusiness]=useState([])
    const [status,setStatus]=useState(false)
const [edit,setEdit]=useState('')
  
    useEffect(() => {
      if(!auth.auth){
        window.location.href='/signin'
      }
      else{
        fetch(live+`businessList?q=${auth.auth.memberID}`,
         { method: 'GET',
         headers:{
           'Content-Type' :'application/json'  
         },})
         .then(res => res.json())
         .then(resp=>Business(resp))
      }
       }, [auth.auth])

   const Business=(val)=>{
       setBusiness(val)
       setStatus(true)
   }
    // console.log(vcard)
  
   
    const copyToClipboard = (valu) => {
        setCopy(true)
 
       const el = document.createElement('textarea');
       el.value =valu;
       document.body.appendChild(el);
       el.select();
       document.execCommand('copy');
       document.body.removeChild(el);
 
 
     };
      


 
    return(   
      <div>    


        <SiteManager  memberID={ auth?.auth?.memberID }/>      
      </div>)
  
  }
  

